// extracted by mini-css-extract-plugin
export default {"footer-container":"footer_footer-container__xDkDf","bg-white":"footer_bg-white__+tFYG","bg-grey":"footer_bg-grey__45RK6","column-container":"footer_column-container__GaYl5"};